import { Position } from './position';

export class Shift {
  name: string;
  site: string;
  start: string;
  end: string;
  positions: Position[];
  isGenerated = 0;
  isCovid = 0;
  covidId: 0;
}
